<header class="col-12 d-flex align-items-center flex-column">
    <img src="/assets/images/logo.png">
    <span *ngIf="$instanceName | async as instanceName" class="mt-2">{{instanceName}}</span>
    <span class="mt-2">{{'general.title' | translate}}</span>
</header>
